<template>
  <div class="brand-graphs-content" id="plataforma-de-marca-descricao-e-graficos" data-search-anchor>
    <div class="graph-description-content">
      <div class="description-brand-graph">
        <p class="brand-graphs-description">{{ BrandGraphsDescription1 }}</p>
        <p class="brand-graphs-description">{{ BrandGraphsDescription2 }}</p>
        <p class="brand-graphs-description">{{ BrandGraphsDescription3 }}</p>
      </div>

      <div class="brand-graphs-row1">
        <div class="brand-graph-card-item" :style="{ backgroundImage: `url(${ImageSrc1})` }"></div>
      </div>
    </div>

    <div class="graph-description-content">
      <div class="brand-graphs-row2">
        <div class="brand-graph-card-item" :style="{ backgroundImage: `url(${ImageSrc2})` }"></div>
      </div>
      <div class="graph-description-content-2">
        <p class="brand-graphs-description">{{ BrandGraphsDescription4 }}</p>
        <p class="brand-graphs-description">{{ BrandGraphsDescription5 }}</p>
        <p class="brand-graphs-description" style="margin-bottom: 0;">{{ BrandGraphsDescription6 }}</p>
        
        <div class="button-main-brand-graphs-wrapper">
        <RedirectOneDriveButton
          :linkUrl="onedriveUrl"
          buttonText="Baixar aqui"          
          />        
        </div>    
      </div>      
    </div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import BrandPlataformPageMixin from '@/mixins/brand-plataform-page-mixin'
import { BrandPlataformPageStore } from '@/store/brand-plataform-page/brand-plataform-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class BrandGraphsSection extends Mixins(BrandPlataformPageMixin) {
  brandPlataformPageStore: PageStoreContract = getModule(BrandPlataformPageStore, this.$store)

  onedriveUrl = 'https://tvglobocorp.sharepoint.com/sites/intranetconexao/DocumentosMarca/Plataforma%20de%20Marca/Plataforma%20de%20Marca.pdf'

  get BrandGraphsDescription1(): string {
    return this.getElementText(2, 0)
  }

  get BrandGraphsDescription2(): string {
    return this.getElementText(2, 1)
  }

  get BrandGraphsDescription3(): string {
    return this.getElementText(2, 2)
  }

  get ImageSrc1(): string {
    return this.getElementMedia(2, 3)
  }

  get BrandGraphsDescription4(): string {
    return this.getElementText(2, 4)
  }

  get BrandGraphsDescription5(): string {
    return this.getElementText(2, 5)
  }

  get BrandGraphsDescription6(): string {
    return this.getElementText(2, 6)
  }
 
  get ImageSrc2(): string {
    return this.getElementMedia(2, 7)
  }

  async getBrandPlataformPage(): Promise<void> {
    await this.brandPlataformPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.brandPlataformPageStore.isLoading) {
      await this.getBrandPlataformPage()
    }
  }
}
</script>

<style lang="scss">
.brand-graphs-content {
  display: flex;
  flex-direction: column;
  max-width: 1032px;
  width: 100%;  
}
    
.graph-description-content {    
  display: grid;
  grid-template-columns: 50% 50%;
  margin-top: 4rem;   
}

.description-brand-graph{
  margin-top: 10rem;
  width: 401px;
}

.brand-graphs-description {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;  
}

.brand-graphs-row1{
  background: none;
  display: grid;
  justify-items: center;
  padding-bottom: 4rem;
}

.brand-graphs-row2 { 
  background: none;
  display: grid;
  justify-items: center;
  justify-content: space-evenly;
  align-items: center;  
  padding-bottom: 4rem;
}  

.brand-graph-card-item {
  position: relative;
  bottom: 0;
  width: 518px !important;
  height: 518px !important;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
  
.brand-graphs-row2 {    
  .brand-graph-card-item {     
    margin-right: 6rem;
    width: 427px !important;
    height: 427px !important;  
  }
}

.graph-description-content-2{
  margin-top: 3.3rem;
  width: 445px;
}

.button-main-brand-graphs-wrapper {
  position: relative;
  top: 2.43rem;
}
</style>
